import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { atpUsersService } from "../../services/atpUsersService";

const initialState = {
    loading: false,
    profileData: {},
    cpds: [],
    search: "",
    organizationName: [],
    cpdSubmissionIdDetails: [],
    cpdActivityIdDetails: [],
    selectedIDforStatusChange: [],
    firstSelectedStatus: "",
    firstSelectedCategory: null,
    bulkCPDIDStatusChange: [],
    atpUserRegistrationDateForCPDActivities: null,
};

export const fetchUserAtpProfile = createAsyncThunk("atp/fetchUserAtpProfile", async ({ id }, thunkAPI) => {
    try {
        const response = await atpUsersService.getUserAtpProfile({
            id,
        });
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

export const updateUserAtpProfileStatus = createAsyncThunk("atp/updateUserAtpProfileStatus", async ({ id, atp_profile_status, reason, navigate }, thunkAPI) => {
    // Accepting user_id and cpd_id
    try {
        const response = await atpUsersService.updateUserAtpStatus(id, {
            atp_profile_status: parseInt(atp_profile_status),
            reason: reason,
        });
        toast.success(response?.data?.message);
        return response?.data?.data;
    } catch (error) {
        toast.error(error?.response?.data?.message);
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        handleLoading: (state, action) => {
            state.loading = action.payload;
        },
        logoutgeneral: (state, action) => {
            return initialState;
        },
        handleSearch: (state, action) => {
            state.search = action.payload;
        },
        setCPD: (state, action) => {
            state.cpds = action.payload;
        },
        setOrganizationName: (state, action) => {
            state.organizationName = action.payload;
        },
        setFirstSelectedStatus: (state, action) => {
            state.firstSelectedStatus = action.payload;
        },
        handleCPDSubmissionEditIdDetails: (state, action) => {
            state.cpdSubmissionIdDetails = action.payload;
        },
        handleCPDActivityEditIdDetails: (state, action) => {
            state.cpdActivityIdDetails = action.payload;
        },
        setIDforStatusChange: (state, action) => {
            state.selectedIDforStatusChange = action.payload;
        },
        setFirstSelectedCategory: (state, action) => {
            state.firstSelectedCategory = action.payload;
        },
        setBulkCPDStatusChange: (state, action) => {
            state.bulkCPDIDStatusChange = action.payload;
        },
        handleatpUserRegistrationDateForCPDActivities: (state, action) => {
            state.atpUserRegistrationDateForCPDActivities = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserAtpProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserAtpProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profileData = { ...action.payload };
            })
            .addCase(fetchUserAtpProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateUserAtpProfileStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateUserAtpProfileStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.profileData = { ...action.payload };
            })
            .addCase(updateUserAtpProfileStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

// Export the actions and reducer
export const {
    handleLoading,
    logoutgeneral,
    handleSearch,
    setCPD,
    setOrganizationName,
    handleCPDSubmissionEditIdDetails,
    handleCPDActivityEditIdDetails,
    setIDforStatusChange,
    setFirstSelectedStatus,
    setFirstSelectedCategory,
    setBulkCPDStatusChange,
    handleatpUserRegistrationDateForCPDActivities
} = generalSlice.actions;
export default generalSlice.reducer;
